"use client";

import { useState } from 'react';
import { Eye } from 'lucide-react';
import styles from './PasswordInput.module.css';

type Props = {
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
};

export default function PasswordInput({ id, name, placeholder, value, onChange, required }: Props) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.wrapper}>
      <input
        type={visible ? "text" : "password"}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
      <button
        type="button"
        className={styles.eye}
        onMouseDown={() => setVisible(true)}
        onMouseUp={() => setVisible(false)}
        onMouseLeave={() => setVisible(false)}
        tabIndex={-1}
      >
        <Eye size={16} />
      </button>
    </div>
  );
}
